// extracted by mini-css-extract-plugin
export default {"ctaBtn":"CTABtn_ctaBtn__jEVy1","small":"CTABtn_small__RvXH0","iconOnly":"CTABtn_iconOnly__jpU1s","large":"CTABtn_large__WjFsO","wide":"CTABtn_wide__c4iZU"};